export { default as FigmaGreen } from './FigmaGreen.jsx';
export { default as FigmaBlue } from './FigmaBlue.jsx';
export { default as FigmaPurple } from './FigmaPurple.jsx';
export { default as FigmaRed } from './FigmaRed.jsx';